import { GridLegacy } from "@mui/material";
import React, { useState } from "react";
import Button from "../../../components/CustomButtons/Button";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import CikamStatusModal from "./CikamStatusModal";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import { useFormContext } from "react-hook-form";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";

function Cikam(props) {
  const [statusModal, setStatusModal] = useState(false);
  const { menukaartVestigingId, vestigingId } = useFormContext();
  return (
    <>
      <FormTextTC
        name={"pay_provider_sec__cikam__apiKey"}
        tDefault={"apikey"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.pay_provider_sec__cikam__apiKey"}
      />
      <FormTextTC
        name={"pay_provider_sec__cikam__ipAddress"}
        tDefault={"ip address"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.pay_provider_sec__cikam__ipAddress"}
      />
      <FormTextTC
        name={"pay_provider_sec__cikam__port"}
        tDefault={"port"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.pay_provider_sec__cikam__port"}
      />
      <FormSwitchTC
        name={"pay_provider_sec__cikam__roundOff"}
        tDefault={"Afronden"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.pay_provider_sec__cikam__roundOff"}
      />

      <FormAsyncTC
        async={{
          url:
            "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
            menukaartVestigingId,
          searchField: "naam",
        }}
        key={"pay_provider_sec__cikam__roundOffProductId" + menukaartVestigingId}
        name={"pay_provider_sec__cikam__roundOffProductId"}
        nullable={true}
        tDefault={"Product voor afronding"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.pay_provider_sec__cikam__roundOffProductId"}
      />

      <GridLegacy item sm={4} xs={12} />
      <GridLegacy item sm={8} xs={12}>
        <Button color={"success"} onClick={() => setStatusModal(true)}>
          <TranslationWrapper tDefault={"Status"} tKey={"vestigingen.form.cikam.button.status"} />
        </Button>
      </GridLegacy>

      <CikamStatusModal
        open={statusModal}
        toggle={() => {
          setStatusModal(false);
        }}
        vestiging_id={vestigingId}
      />
    </>
  );
}

export default Cikam;
